export const StatusRead = {
    INPROGRESS: 1,
    SAVED: 2,
    FINISHED: 3,
    DELETE: 4
}